import React, { Component } from 'react';
import PropTypes from 'prop-types';

import withJsScript from 'client/helpers/withJsScript';
import log from 'client/lib/log';
import branch from 'client/core/branch';

const SR_VOUCHED_CONTAINER_REF_ID = 'srVouchedContainerRefId';

@withJsScript({
  preventRender: true,
  scriptUrl: (
    'https://static.vouched.id/widget/vouched-2.0.0.js'
  ),
})
@branch({
  VOUCHED_PUBLIC_API_KEY: ['env', 'VOUCHED_PUBLIC_API_KEY'],
})
class SrIdVerificationModal extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onCamera: PropTypes.func.isRequired,
    onInit: PropTypes.func.isRequired,
    onDone: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this._onDoneCalled = false;
    if (typeof global.Vouched !== 'function') {
      log.error('global.Vouched is not an object.');
      return;
    }
    /* eslint-disable max-len */
    const vouched = global.Vouched({
      appId: props.VOUCHED_PUBLIC_API_KEY,
      crossDevice: true,
      crossDeviceQRCode: true,
      type: 'idv',
      face: 'camera',
      id: 'camera',
      onSubmit: props.onSubmit,
      onCamera: props.onCamera,
      onInit: props.onInit,
      onDone: this._onDone,
      stepTitles: {
        FrontId: 'Upload ID',
        Face: 'Upload Headshot',
        Done: '',
      },
      liveness: 'orientation',
      showProgressBar: false,
      content: {
        cameraButton: 'Take a Photo',
        crossDeviceTitle: 'Identity Verification',
        crossDeviceInstructions: 'We need to verify your identity. This requires government-issued photo ID as well as a selfie. Please follow the instructions below to continue the verification process on your phone.',
        crossDeviceSuccess: 'Verification is complete, continue on your desktop',
        review: '',
        upperSuccess: 'Your photo uploads are complete!',
        success: '',
        lowerSuccess: '',
        upperIdInstructions: 'Before you start please have an approved Government ID (e.g. Passport / Driving License) in your hand.',
        lowerIdInstructions: 'Please take a photo of your ID now',
        upperFaceInstructions: '',
        lowerFaceInstructions: 'Please take a clear picture of your face 😊\nMake sure it does not include:',
        upperFailure: 'Try Again',
        verifyFail: 'Sorry for the inconvenience',
        lowerFailure: 'The photo you shared can\'t be used for validation. Please take another picture, making sure the image of your face or your ID is clear.',
      },
      theme: {
        name: 'verbose',
        font: 'Open Sans',
        handoffLinkColor: '#007AFF',
        fontColor: '#413D3A',
        iconLabelColor: '#413D3A',
        bgColor: '#FFF',
        baseColor: '#FFCD00',
        navigationDisabledBackground: '#FFF7D7',
        navigationDisabledText: '#413D3A',
        navigationActiveText: '#413D3A',
        iconColor: '#F6F5F3',
        iconBackground: '#FFCD00',
      },
    });
    /* eslint-enable max-len */
    this._vouched = vouched;
  }

  _onDone = (...args) => {
    const { onDone } = this.props;
    if (!this._onDoneCalled) {
      this._onDoneCalled = true;
      onDone(...args);
    }
  }

  componentWillUnmount() {
    if (this._vouched) {
      this._vouched.unmount(`#${SR_VOUCHED_CONTAINER_REF_ID}`);
    }
  }

  _onVouchedContainerRef = () => {
    setTimeout(() => {
      if (this._vouched) {
        this._vouched.mount(`#${SR_VOUCHED_CONTAINER_REF_ID}`);
      }
    }, 200);
  }

  render() {
    const { VOUCHED_PUBLIC_API_KEY } = this.props;

    if (!VOUCHED_PUBLIC_API_KEY) {
      return (
        <div>
          Sorry, Vouched is not enabled in this environment.
        </div>
      );
    }

    return (
      <div
        id={SR_VOUCHED_CONTAINER_REF_ID}
        style={{ height: '100%' }}
        ref={this._onVouchedContainerRef}
      />
    );
  }
}

SrIdVerificationModal.displayName = 'SrIdVerificationModal';

export default SrIdVerificationModal;
